import React from 'react'

import Section from '../Section'

import emailIcon from 'assets/images/contacts/Editor/editor-email-20.svg'

import { useTranslation } from 'react-i18next'

interface EmailsProps {
  editData: any
  onFieldChange: (propName: string, index: number, value: any) => void
  onLabelChange: (propName: string, index: number, label: string) => void
  onAddItem: (propName: string, label: string) => void
  onDelete: (propName: string, index: number) => void
}

const Emails = ({ editData, onFieldChange, onLabelChange, onAddItem, onDelete }: EmailsProps) => {
  const { t } = useTranslation()
  return (
    <Section
      editData={editData}
      propName="emails"
      labelList={[
        { key: 'work', label: t('contact.property.work') },
        { key: 'personal', label: t('contact.title.personal') },
        { key: 'other', label: t('contact.property.other') },
        { key: '', label: t('contact.property.none') },
        { key: 'custom', label: t('contact.property.custom') },
      ]}
      icon={emailIcon}
      addButtonLabel={t('contact.menu.addEmail')}
      onFieldChange={onFieldChange}
      onLabelChange={onLabelChange}
      onAddItem={onAddItem}
      onDelete={onDelete}
      canDelete={(index) => index !== 0}
    />
  )
}
export default Emails
